var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", { staticClass: "white-bg title_container" }, [
        _c("div", { staticClass: "title_container-p" }, [
          _c(
            "div",
            { staticClass: "container container-kernel" },
            [
              _vm._t("title", [
                _c("p", { staticClass: "title_page mb-0" }, [
                  _c("span", { staticClass: "h3" }, [_vm._v(_vm._s(_vm.title))])
                ])
              ])
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container container-kernel page" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "back-to-top",
        [
          _c("b-btn", { staticClass: "btn-icon btn-to-top" }, [
            _c("i", { staticClass: "fa fa-chevron-up" })
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/Main.vue?vue&type=template&id=7b85789e&
// module id = null
// module chunks = 